import { render, staticRenderFns } from "./STToolbar.vue?vue&type=template&id=0efbdde4"
import script from "./STToolbar.vue?vue&type=script&lang=ts"
export * from "./STToolbar.vue?vue&type=script&lang=ts"
import style0 from "./STToolbar.vue?vue&type=style&index=0&id=0efbdde4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports